import { HeartPulse } from "lucide-react";
import { type QuizConfig } from "~/types/quiz";

export const proveraNivoaStresa: QuizConfig = {
  id: "provera-nivoa-stresa",
  illustration: {
    src: "/images/quizzes/provera-nivoa-stresa.webp",
    alt: "Muškarac pokušava da odgovori na više obaveza u kuhinji.",
  },
  lastModified: "2026-07-18",
  title: "Koliko si pod stresom?",
  shortTitle: "Koliko si pod stresom?",
  description: "Otkrij svoj nivo stresa i kako da ga držiš pod kontrolom.",
  longDescription:
    "Brz test zasnovan na validiranim skalama stresa koji ti daje jasnu sliku o tome kako stres utiče na tvoje telo, rutinu i odnose. Kombinujemo pitanja o simptomima, navikama i emocionalnim reakcijama da bismo procenili realnu opterećenost organizma. Na kraju dobijaš personalizovane savete kako da uvedeš male promene, prepoznaš rizične obrasce i odlučiš da li je vreme za razgovor sa stručnjakom ili jednostavne promene svakodnevice.",
  duration: "3-5 min",
  icon: HeartPulse,
  category: "Stres i burnout",
  focusAreasWanted: [
    "stress",
    "emotional_regulation",
    "self_development",
    "anxiety",
  ],
  featured: true,
  questions: [
    {
      type: "radio",
      question: "Koliko često se osećaš pod stresom u poslednjih mesec dana?",
      options: ["Nikada", "Retko", "Povremeno", "Često", "Veoma često"],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "radio",
      question: "Da li imaš poteškoća sa spavanjem zbog stresa?",
      options: ["Nikada", "Ponekad", "Često", "Skoro svake noći"],
      scores: [0, 1, 2, 3],
    },
    {
      type: "radio",
      question: "Koliko često osećate nervozu ili napetost?",
      options: ["Nikada", "Ponekad", "Često", "Skoro uvek"],
      scores: [0, 1, 2, 3],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question:
        "Koji simptomi stresa se kod tebe najčešće javljaju? (izaberi sve koji važe)",
      options: [
        "Glavobolja",
        "Napetost mišića",
        "Poteškoće u koncentraciji",
        "Anksioznost",
        "Razdražljivost",
        "Umor",
        "Nemam simptoma",
      ],
      scores: [1, 1, 1, 1, 1, 1, 0],
    },
    {
      type: "radio",
      question:
        "Da li imaš problema sa obavljanjem svakodnevnih aktivnosti zbog stresa?",
      options: ["Nikada", "Retko", "Ponekad", "Često", "Uvek"],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "textarea",
      question:
        "Navedi ako postoji neki specifičan razlog za tvoj trenutni nivo stresa.",
    },
    {
      type: "radio",
      question:
        "Koliko često osećate fizičke simptome stresa, poput ubrzanog pulsa ili preznojavanja?",
      options: ["Nikada", "Retko", "Ponekad", "Često", "Veoma često"],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "radio",
      question:
        "Da li vam je teško da se opustite, čak i kada imate slobodnog vremena?",
      options: ["Nikada", "Ponekad", "Često", "Skoro uvek"],
      scores: [0, 1, 2, 3],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question:
        "Koje metode koristiš za upravljanje stresom? (izaberi sve koje važe)",
      options: [
        "Vežbanje",
        "Meditacija ili joga",
        "Razgovor sa prijateljima ili porodicom",
        "Rad na hobijima",
        "Konzumacija alkohola ili cigareta",
        "Lekovi ili suplementi",
        "Ne koristim nikakve metode",
      ],
      scores: [0, 0, 0, 0, 1, 1, 0],
    },
    {
      type: "textarea",
      question:
        "Imaš li još nešto što želiš da dodaš u vezi sa tvojim trenutnim nivoom stresa?",
    },
  ],
  copy: {
    title: "Tvoj rezultat",
    subtitle: "Razumimo tvoje nivoe stresa i pronađimo načine za poboljšanje.",
    scoreLabel: "Tvoj rezultat:",
    adviceTitle: "Saveti za tebe",
    resourcesTitle: "Korisni resursi",
    whatNextTitle: "Šta sada?",
    shareButtonText: "Podeli rezultat",
  },
};
